var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 0C12.5736 0 16.2 3.62637 16.2 8.1C16.2 12.5736 12.5736 16.2 8.1 16.2C3.62637 16.2 0 12.5736 0 8.1C0 3.62637 3.62637 0 8.1 0ZM8.1 3.24C7.88518 3.24 7.67915 3.32534 7.52724 3.47724C7.37534 3.62915 7.29 3.83518 7.29 4.05V8.1C7.29005 8.31481 7.37542 8.5208 7.52733 8.67267L9.95733 11.1027C10.1101 11.2502 10.3147 11.3319 10.5271 11.33C10.7395 11.3282 10.9426 11.243 11.0928 11.0928C11.243 10.9426 11.3282 10.7395 11.33 10.5271C11.3319 10.3147 11.2502 10.1101 11.1027 9.95733L8.91 7.76466V4.05C8.91 3.83518 8.82466 3.62915 8.67276 3.47724C8.52085 3.32534 8.31483 3.24 8.1 3.24Z",
    fill: "#F3DE8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.beb67d8a7378622084ad1d7c6db63abe.svg";
export { ForwardRef as ReactComponent };